import { TableSelectionEvent } from "@mcleod/components";
import { MapSettings } from "@mcleod/core";
import { AutogenLayoutZoneSuperRegionList } from "./autogen/AutogenLayoutZoneSuperRegionList";
import { MapZoneSelectionUtil } from "./MapZoneSelectionUtil";
import { ZoneMapScreen } from "./MapZoneUtil";

export class ZoneSuperRegionList extends AutogenLayoutZoneSuperRegionList {

    private mapVendor = MapSettings.getSingleton().getZoneMapVendor();
    private mapSelector: MapZoneSelectionUtil;

    override onLoad() {
        this.mainDataSource.search();
        this.mapSelector = new MapZoneSelectionUtil(this.mapVendor, this.mapRoute);
    }

    async tableZoneSuperRegionListOnSelect(event: TableSelectionEvent) {
        await this.mapSelector.handleRowSelection(ZoneMapScreen.ZoneSuperRegion, this.tableZoneSuperRegionList.selectedRow);
    }

}
